<template>
  <div
    ref="promoBarRef"
    v-style:m="{ sm: mobileBlendModeActive ? '0.75rem 0 0 5.5rem' : '0', lg: '0' }"
    class="relative z-header h-8 overflow-hidden p-2 text-xs"
    :class="{
      'bg-black c-white': header.transparent,
      '<lg:fixed <lg:bg-transparent <lg:mix-blend-difference <lg:z-1 <lg:c-white <lg:[mask-image:var(--mi)]': mobileBlendModeActive,
    }"
    :style="mobileBlendModeActive
      ? '--mi: linear-gradient(to right, transparent, black 10%, black 90%, transparent)'
      : ''"
  >
    <base-marquee>
      <template #default="{ cloned }">
        <div
          v-for="(message, i) in content.messages as Message[]"
          :key="i"
          ref="contentRef"
          class="flex items-center"
        >
          <component
            :is="content.directLinks ? BaseLink : BaseButton"
            :tabindex="cloned ? '-1' : undefined"
            :target="content.directLinks ? message.targets?.[0]?.targetAttribute : undefined"
            :to="content.directLinks ? message.targets?.[0]?.url : undefined"
            @click="handleClick"
          >
            <cms-section
              :key="i"
              :section="{ items: [{ ...message, isFullWidth: true }], name: 'promo-bar-message' }"
            />
          </component>
          <span aria-hidden="true" class="mx-6 shrink-0">•</span>
        </div>
      </template>
    </base-marquee>
    <panel-promo-bar v-if="!content.directLinks" :content />
  </div>
</template>

<script lang="ts" setup>
import type { Message, PromoBarContent } from '#types/components/cms/promo-bar'
import { BaseButton, BaseLink } from '#components'

const { content } = defineProps<{ content: PromoBarContent }>()

const { allowMixBlendMode } = useAppConfig().components.cms.promoBar
const { $feature } = useNuxtApp()
const header = useHeaderStore()
const route = useRoute()

const PanelPromoBar = createPanel('promo-bar')

const contentRef = ref()
const promoBarRef = toRef(header.refs, 'promoBar')

const handleClick = () => {
  if (!content.directLinks)
    PanelPromoBar.open()
}

const mobileBlendModeActive = computed(
  () => allowMixBlendMode && $feature.headerMobilePromoBlendModeRoutes.some(
    (pattern) => convertPatternToRegex(pattern).test(route.path)
  )
)
</script>
